"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Jul 10 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductCategoryConverter.
 *
 * @author JMe
 */


var ProductCategoryConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductCategoryConverter, _DataObjectConverter_);

  function ProductCategoryConverter() {
    _classCallCheck(this, ProductCategoryConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductCategoryConverter).apply(this, arguments));
  }

  return ProductCategoryConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductCategoryConverter = ProductCategoryConverter;